<!-- Enforcement notice subsection -->
<h3 class="subsection-heading">Enforcement notice</h3>
<p class="section-description">
  The permanent Enforcement Mode indicator shown in Account Settings → General when backups are suspended. It appears
  when the entitlement reports <code>backupsSuspended</code>, which the server sets once usage goes above 105% of
  contracted capacity (account-general's <code>isInEnforcementMode</code> gate). Toggle the gate's two outcomes below.
</p>
<div class="chart-scenario-toggle">
  <button
    type="button"
    class="chart-scenario-btn"
    [class.active]="enforcementNoticeState === 'suspended'"
    (click)="setEnforcementNoticeState('suspended')"
    title="Usage above 105% with backups suspended — notice shown"
  >
    Suspended (>105%)
  </button>
  <button
    type="button"
    class="chart-scenario-btn"
    [class.active]="enforcementNoticeState === 'within'"
    (click)="setEnforcementNoticeState('within')"
    title="Within contracted capacity — no notice"
  >
    Within capacity
  </button>
</div>
<!-- Mirrors the notice's real home: the white Account Settings content surface with prod padding. -->
<div class="usage-notice-surface">
  @if (enforcementNoticeState === 'suspended') {
    <enforcement-mode-notice class="double-margin-bottom" />
  } @else {
    <div class="usage-notice-empty">No enforcement notice — account is within contracted capacity.</div>
  }
</div>

<!-- Dashboard subsection -->
<h3 class="subsection-heading">Dashboard</h3>
<p class="section-description">
  The real Usage &amp; Billing dashboard rendered against a patched <code>loadDashboard</code>. Unlike the Recovery and
  Backup previews this one is interactive — the period presets, Daily/Monthly toggle, cloud filter, tab switch, search
  and row expansion all work, and most states are only reachable through them. Export is live and will hit the real API.
</p>

<label class="recovery-screen-picker">
  <span class="recovery-screen-picker-label">Scenario</span>
  <select class="arpio-select" (change)="setUsageBillingScenario($any($event.target).value)">
    <optgroup *ngFor="let group of usageBillingScenarioGroups" [label]="group.label">
      <option
        *ngFor="let scenario of group.scenarios"
        [value]="scenario.key"
        [selected]="scenario.key === usageBillingScenarioKey"
      >
        {{ scenario.label }}
      </option>
    </optgroup>
  </select>
</label>
<p class="recovery-screen-description">{{ usageBillingActiveScenario.description }}</p>

<!-- The page assumes it owns the viewport (sticky header, 100vh-based
     pane height), so the frame gives it a bounded height and its own
     scroll context. Sticky pinning therefore differs slightly from the
     real route — verify that on /account/usage itself. -->
<div class="usage-billing-frame">
  <app-usage-billing *ngIf="usageBillingMounted"></app-usage-billing>
</div>
